<template>
  <section class="about">
    <container>
      <h2 class="about__title">Über uns</h2>
      <section class="about__section">
        <h3 class="about__section__title">Mit der Jugend in die Zukunft!</h3>
        <p class="about__section__text">Die Jugend ist uns wichtig – denn ohne Jugend gibt es für den Handballsport
          keinen Zukunft. Daher wurde der Förderverein Club der 100 e.V. gegründet um die Jugend zu fördern und dort zu
          unterstützen wo der Handballcub Maulburg und die Handballabteilung des TV Steinen in der gemeinsamen SG (<a
            style="color: #000000;" href="http://www.sg-maulburg-steinen.de/">www.sg-maulburg-steinen.de</a>) an ihre
          Grenzen stößt.</p>
        <img src="../../assets/backgrounds/action-compressor.jpg" alt="Bild" class="about__section__image"
             align="right">
        <p class="about__section__text">So konnten in den letzten Jahren mit vielen Maßnahmen die Jugend gezielt
          gefördert werden. Sei es mit Trikots, Trainingsbällen, Schulungsmaterial oder einem Zuschuß für die Teilnahme
          an Jugendturnieren.</p>
        <p class="about__section__text">Wir freuen uns über Ihr Interesse am Förderverein Club-der-100 e.V. und möchten
          Ihnen auf den folgenden Seiten einen Einblick in unsere Förderverein geben.</p>
        <p class="about__section__text">Wenn Sie Fragen oder Interesse an uns und unserer Tätigkeit haben, nehmen Sie <a
          href="#kontakt">Kontakt</a> mit uns auf – wir stehen Ihnen gerne zur Verfügung und freuen uns über
          Unterstützung für die Jugend.</p>
      </section>

      <section class="about__section">
        <h3 class="about__section__title">Club der 100 unterstützt mit Trainingsutensilien</h3>
        <p class="about__section__text">Der Club der 100 ist unterstützend bei der SG
          Maulburg/Steinen aktiv. Um adäquates, modernes Training anbieten zu können, benötigen die Trainer und
          Mannschaften begleitende Trainingsutensilien. Hierzu konnten wir unseren Beitrag leisten und in größerem Maße
          Trainings-Material spenden, damit der Verein weiterhin den gehobenen Ansprüchen in der Trainingslehre gerecht
          werden kann.</p>
      </section>

      <section class="about__section">
        <div class="about__section__split">
          <div class="about__section__split__item">
            <img :src=" content.board_image.path " alt="Vorstand" class="about__section__image">
            <small class="about__section__caption">{{ content && content.board_imagecaption }}
            </small>
          </div>
          <div class="about__section__split__item">
            <h3 class="about__section__title">Die Vorstandschaft</h3>
            <p class="about__section__text" style="white-space:pre-wrap;word-wrap:break-word" v-html=" content && content.board_names "></p>
          </div>
        </div>
      </section>
    </container>
    <slot name="append"></slot>
  </section>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'OnepageAbout',
    props: ['general'],
    components: {Container},
    data () {
      return {
        content: false
      }
    },
    mounted () {
      api.singleton.get('about').then(response => {
        this.content = JSON.parse(response.data)
        this.content.board_image.path = api.url + this.content.board_image.path
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .about {
    &__title {
      margin: 0;
      font-size: $size_title-big;
      text-align: center;
    }

    &__section {
      padding: 4rem 2rem;

      &__title {
        margin: $spacing_title;
        font-size: $size_title;
      }

      &__text {
        margin-bottom: 1rem; // margin-bottom: __caption outer height
        font-size: $size_text;

        & + & {
          margin-top: 1.25rem;
        }
      }

      &__image {
        border-radius: 1rem;
        width: 100%;

        &[align] {
          width: 33%;
        }
      }
      &__caption {
        margin-top: .2rem;
        font-size: $size_text-small;
        line-height: 1;
        height: .8rem;
        text-align: center;
        display: block;
        color: $text-muted;
      }

      $cache: &;
      &__split {
        display: flex;
        justify-content: space-around;
        align-items: center;

        &__item {
          width: 55%;
        }
        &__item + &__item {
          width: 35%;
        }
      }

      & + & {
        border-top: 1px solid $gray;
      }
      &:last-of-type {
        padding-bottom: 0;
        margin-bottom: -2rem;
      }
    }

    @media (max-width: 777px) {
      &__section {
        padding: 2rem 0;
        &__title {
          text-align: center
        }
        &__image[align] {
          width: 100%;
          margin-bottom: 1rem;
        }
        &__text {
          text-align: justify
        }
        &__split {
          flex-direction: column-reverse;
          &__item {
            width: 100% !important
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/onepage/about.vue